export const DIVIDER_HEIGHT = 30;
export const SPACING_BETWEEN_CATEGORIES = 0.75;
